import { LinkObj } from '@repo/ui/src/types/link';
import { BreadcrumbJsonLd } from 'next-seo';

export interface BreadcrumbSeoProps {
  breadcrumbs: Array<LinkObj>;
}

const BreadcrumbSeo = ({ breadcrumbs }: BreadcrumbSeoProps) => {
  return (
    <BreadcrumbJsonLd
      useAppDir
      itemListElements={breadcrumbs.map((breadcrumb, index) => ({
        name: breadcrumb.text,
        item: `${process.env.NEXT_PUBLIC_WEB_ENV}${breadcrumb.href}`,
        position: index + 1,
      }))}
    />
  );
};

export default BreadcrumbSeo;
